@if (open) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show detail-modal" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        @if (isCreateMode()) {
        <h2 class="modal-title">{{ 'pages.users.modal.create-title' | translate }}</h2>
        } @else {
        <h2 class="modal-title">{{ 'pages.users.modal.edit-title' | translate }}</h2>
        }

        <button class="btn-close" type="button" (click)="closeDetailModal()"></button>
      </div>

      <form class="modal-body" [formGroup]="form" (ngSubmit)="save()">
        <ul class="nav nav-tabs user-modal-tabs">
          <li class="nav-item">
            <button class="nav-link" [class.active]="activeTab() === 'general'" type="button"
              (click)="selectTab('general')">
              {{ 'pages.users.tabs.general' | translate }}
            </button>
          </li>
          <li class="nav-item">
            <button class="nav-link" [class.active]="activeTab() === 'authorization'" type="button"
              (click)="selectTab('authorization')">
              {{ 'pages.users.tabs.authorization-account' | translate }}
            </button>
          </li>
        </ul>

        <div class="tab-content user-modal-tab-content">
          @if (activeTab() === 'general') {
          <div class="tab-pane fade show active">
            <div class="form-grid">
              <app-input-block [invalid]="isInvalid('username')" controlId="username" controlName="username"
                inputType="email" labelKey="pages.users.fields.username" [readonly]="isEditMode()">
                @if (hasError('username', 'required') && isInvalid('username')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.username-required' | translate }}</div>
                }
                @if (hasError('username', 'email') && isInvalid('username')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.username-format' | translate }}</div>
                }
                @if (hasError('username', 'maxlength') && isInvalid('username')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.username-maxlength' | translate }}</div>
                }
              </app-input-block>
              @if (searchedPerson()){
              <app-input-block [invalid]="isInvalid('firstName')" controlId="first-name" controlName="firstName"
                labelKey="pages.users.fields.first-name">
                @if (hasError('firstName', 'required') && isInvalid('firstName')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.first-name-required' | translate }}</div>
                }
                @if (hasError('firstName', 'maxlength') && isInvalid('firstName')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.first-name-maxlength' | translate }}</div>
                }
              </app-input-block>

              <app-input-block [invalid]="isInvalid('lastName')" controlId="last-name" controlName="lastName"
                labelKey="pages.users.fields.last-name">
                @if (hasError('lastName', 'required') && isInvalid('lastName')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.last-name-required' | translate }}</div>
                }
                @if (hasError('lastName', 'maxlength') && isInvalid('lastName')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.last-name-maxlength' | translate }}</div>
                }
              </app-input-block>

              <app-input-block [invalid]="isInvalid('phone')" controlId="phone" controlName="phone"
                labelKey="pages.users.fields.phone">
                @if (hasError('phone', 'maxlength') && isInvalid('phone')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.phone-maxlength' | translate }}</div>
                }
              </app-input-block>

              <app-input-block [fullWidth]="true" controlId="contact" controlName="contact" inputType="checkbox"
                labelKey="pages.users.fields.contact" />

              <app-input-block [fullWidth]="true" [invalid]="isInvalid('avatar')" controlId="avatar"
                controlName="avatar" labelKey="pages.users.fields.avatar">
                @if (hasError('avatar', 'maxlength') && isInvalid('avatar')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.avatar-maxlength' | translate }}</div>
                }
                @if (hasError('avatar', 'url') && isInvalid('avatar')) {
                <div class="invalid-feedback">{{ 'pages.users.validation.avatar-url-format' | translate }}</div>
                }
              </app-input-block>

              <div class="field-block field-block-full">
                <label class="form-label" for="profile-selector">{{ 'pages.users.fields.profiles' | translate }}</label>
                <div class="input-group">
                  <select class="form-select" [disabled]="saving() || deleting() || selectedAccountId() === null"
                    id="profile-selector" [value]="selectedProfileId() ?? ''"
                    (change)="onProfileSelectionChange($event)">
                    <option value="">{{ 'pages.users.profiles.select-placeholder' | translate }}</option>
                    @for (profile of selectableProfiles(); track profile.id ?? profile.name) {
                    <option [value]="profile.id ?? ''">{{ profile.application?.name }} - {{ profile.name }}
                    </option>
                    }
                  </select>
                  <button class="btn btn-light" [disabled]="selectedProfileId() === null || saving() || deleting()"
                    type="button" (click)="addSelectedProfile()">
                    <i class="fa-solid fa-plus" aria-hidden="true"></i>
                    {{ 'pages.users.profiles.add' | translate }}
                  </button>
                </div>
                @if (profiles().length === 0) {
                <div class="relations-empty mt-2">{{ 'pages.users.profiles.empty' | translate }}</div>
                } @else {
                <ul class="relations-list mt-2">
                  @for (profile of profiles(); track profile.id ?? profile.name) {
                  <li class="relation-item">
                    <span class="relation-label">{{ profile.application?.code ?? '-' }} / {{ profile.name }}</span>
                    @if (profile.id !== null) {
                    <button class="btn btn-light btn-sm" [disabled]="saving() || deleting()" type="button"
                      (click)="removeProfile(profile.id)">
                      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                      {{ 'pages.users.profiles.remove' | translate }}
                    </button>
                    }
                  </li>
                  }
                </ul>
                }
              </div>
              }

              @if (isEditMode()) {
              <app-input-block [readonly]="true" [value]="selectedCreatedAt()" controlId="created-at"
                labelKey="pages.users.fields.created-at" />

              <app-input-block [readonly]="true" [value]="selectedUpdatedAt()" controlId="updated-at"
                labelKey="pages.users.fields.updated-at" />
              }
            </div>
          </div>
          } @else {
          <div class="tab-pane fade show active">
            @if (isCreateMode()) {
            <div class="auth-account-placeholder">
              {{ 'pages.users.authorization-account.create-first' | translate }}
            </div>
            } @else {
            <section class="auth-account-panel">
              <div class="auth-account-header">
                <div>
                  <h3 class="auth-account-title">{{ 'pages.users.authorization-account.title' | translate }}</h3>
                  <p class="auth-account-subtitle">{{ 'pages.users.authorization-account.subtitle' | translate }}</p>
                </div>
                <span class="{{ authorizationAccountStatusClass() }}">
                  {{ authorizationAccountStatusKey() | translate }}
                </span>
              </div>

              <div class="auth-account-grid">
                @if (hasAuthorizationAccount()) {
                <app-input-block [readonly]="true"
                  [value]="('pages.users.authorization-account.auth-types.' + authorizationAccount()?.['auth-type']) | translate"
                  controlId="authorization-auth-type" labelKey="pages.users.authorization-account.fields.auth-type" />
                } @else {
                <div class="field-block">
                  <label class="form-label" for="authorization-auth-type-select">
                    {{ 'pages.users.authorization-account.fields.auth-type' | translate }}
                  </label>
                  <select class="form-select"
                    [disabled]="saving() || deleting() || authorizationAccountBusy() || authorizationAccountLookupState() !== 'missing'"
                    id="authorization-auth-type-select" [value]="authorizationAccountType()"
                    (change)="onAuthorizationAccountTypeChange($event)">
                    @for (authType of supportedAuthTypes; track authType) {
                    <option [value]="authType">
                      {{ ('pages.users.authorization-account.auth-types.' + authType) | translate }}
                    </option>
                    }
                  </select>
                </div>
                }

                <div class="field-block">
                  <label class="form-label" for="authorization-language-select">
                    {{ 'pages.users.authorization-account.fields.preferred-language' | translate }}
                  </label>
                  <div class="input-group">
                    <select class="form-select"
                      [disabled]="saving() || deleting() || authorizationAccountBusy() || authorizationAccountLookupState() === 'loading' || authorizationAccountLookupState() === 'error'"
                      id="authorization-language-select" [value]="authorizationAccountLanguage()"
                      (change)="onAuthorizationLanguageChange($event)">
                      @for (language of supportedLanguages; track language.code) {
                      <option [value]="language.code"
                        [selected]="this.authorizationAccount()?.['preferred-language'] === language.code">
                        {{ ('pages.users.authorization-account.languages.' + language.code) | translate }}
                      </option>
                      }
                    </select>
                  </div>
                </div>

                @if (authorizationAccountLookupState() === 'loading') {
                <div class="auth-account-message">
                  {{ 'pages.users.authorization-account.states.loading' | translate }}
                </div>
                } @else if (authorizationAccountLookupState() === 'error') {
                <div class="auth-account-message auth-account-message-error">
                  {{ 'pages.users.authorization-account.states.unavailable' | translate }}
                </div>
                } @else if (authorizationAccountLookupState() === 'missing') {
                <div class="auth-account-create">
                  <p class="auth-account-message">
                    {{ 'pages.users.authorization-account.empty' | translate }}
                  </p>
                  <button class="btn btn-primary"
                    [disabled]="saving() || deleting() || authorizationAccountBusy() || !currentUsername()"
                    type="button" (click)="createAuthorizationAccount()">
                    <i class="fa-solid fa-user-check" aria-hidden="true"></i>
                    {{ 'pages.users.authorization-account.actions.activate-user' | translate }}
                  </button>
                </div>
                } @else if (hasAuthorizationAccount() && isAuthorizationAccountInternal()) {
                <div class="auth-account-summary">
                  <div class="auth-account-summary-item">
                    <span class="auth-account-summary-label">
                      {{ 'pages.users.authorization-account.fields.failed-attempts' | translate }}
                    </span>
                    <strong>{{ authorizationAccount()?.['failed-attempts'] ?? 0 }}</strong>
                  </div>
                  <div class="auth-account-summary-item">
                    <span class="auth-account-summary-label">
                      {{ 'pages.users.authorization-account.fields.change-password' | translate }}
                    </span>
                    <strong>
                      {{
                      ('pages.users.authorization-account.boolean.' + ((authorizationAccount()?.['change-password'] ??
                      false) ? 'yes' : 'no'))
                      | translate
                      }}
                    </strong>
                  </div>
                  <div class="auth-account-summary-item">
                    <span class="auth-account-summary-label">
                      {{ 'pages.users.authorization-account.fields.otp-status' | translate }}
                    </span>
                    <strong>
                      {{
                      ('pages.users.authorization-account.otp.' + (isAuthorizationOtpEnabled() ? 'enabled' :
                      'disabled'))
                      | translate
                      }}
                    </strong>
                  </div>
                </div>

                <div class="auth-account-actions">
                  <button class="btn btn-light btn-sm"
                    [attr.aria-label]="'pages.users.authorization-account.actions.reset' | translate"
                    [disabled]="saving() || deleting() || authorizationAccountBusy()"
                    [title]="'pages.users.authorization-account.actions.reset' | translate" type="button"
                    (click)="resetAuthorizationAccount()">
                    <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
                  </button>

                  <button class="btn btn-light btn-sm"
                    [attr.aria-label]="'pages.users.authorization-account.actions.request-password-change' | translate"
                    [disabled]="saving() || deleting() || authorizationAccountBusy()"
                    [title]="'pages.users.authorization-account.actions.request-password-change' | translate"
                    type="button" (click)="requestAuthorizationAccountPasswordChange()">
                    <i class="fa-solid fa-key" aria-hidden="true"></i>
                  </button>

                  <div class="form-check form-switch auth-account-switch">
                    <input class="form-check-input" [checked]="isAuthorizationOtpEnabled()"
                      [disabled]="saving() || deleting() || authorizationAccountBusy() || isAuthorizationOtpEnabled()"
                      id="authorization-otp" type="checkbox" (change)="onAuthorizationOtpChange($event)" />
                    <label class="form-check-label" for="authorization-otp">
                      {{ 'pages.users.authorization-account.actions.enable-otp' | translate }}
                    </label>
                  </div>
                </div>
                }
              </div>
            </section>
            }
          </div>
          }
        </div>
      </form>

      <div class="modal-footer">
        @if (isEditMode()) {
        <button class="btn btn-light btn-danger-soft me-auto"
          [disabled]="saving() || deleting() || authorizationAccountBusy()" type="button" (click)="requestDelete()">
          <i class="fa-solid fa-trash" aria-hidden="true"></i>
          {{ 'pages.users.actions.delete' | translate }}
        </button>
        }

        @if (!searchedPerson()){
        <div class="d-flex justify-content-start" style="height:48px;">
          <button class="btn btn-primary" [disabled]="searching()" type="button" (click)="searchPerson()">
            <i class="fa-solid fa-person-circle-question" aria-hidden="true"></i>
            {{ 'pages.users.actions.search' | translate }}
          </button>
        </div>
        }@else {

        <button class="btn btn-light" [disabled]="saving() || deleting() || authorizationAccountBusy()" type="button"
          (click)="closeDetailModal()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          {{ 'pages.users.actions.cancel' | translate }}
        </button>

        <button class="btn btn-primary" [disabled]="saving() || deleting() || authorizationAccountBusy()" type="button"
          (click)="save()">
          <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
          {{ 'pages.users.actions.save' | translate }}
        </button>
        }
      </div>
    </div>
  </div>
</div>
}